<template>

  <div class="value">
    <span class="old" v-if="different">{{ oldValue }}</span>
    <span class="new" :class="{ different: different }">{{ newValue }}</span>
  </div>

</template>

<script>
  export default {
    name: 'value-difference',

    props: [ 'oldValue', 'newValue' ],

    computed: {
      different () {
        return this.oldValue !== this.newValue
      }
    }
  }
</script>

<style scoped lang="scss">

  @import '../../../assets/variables';

  .value {
    .old {
      text-decoration: line-through;
      color: #ef2a11;
      margin-right: 5px;
    }

    .new.different {
      color: #3b8709;
    }
  }

</style>
